import { z } from "zod";
import type { AccountType } from "@relay/editLeadStrategyForm_AccountFragment.graphql";

export const EditLeadStrategyFormSchema = z.object({
	leadStrategy: z.enum(["ProductLed", "SalesLed"] as [AccountType, ...AccountType[]], {
		required_error: "Lead Strategy is required",
	}),
	domain: z.string().optional(),
});
